module.exports = __webpack_public_path__ + "img/Zaki_Hilal_Saud.3b6f9075.png";